import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../../lib/hooks/use-auth";
import { useListTree, useWorkspaceInfo } from "../../lib/hooks/use-kuvio";
import { useOnboardingComplete } from "../hooks/use-onboarding";

/**
 * `/` — the console entry point.
 *
 * Sprint 23.7: Home is now `/workforce` (the de-facto home until 23.8's
 * workspace overview). A brand-new workspace — no agents and onboarding not yet
 * completed — lands on `/welcome` instead. Existing workspaces (any with agents)
 * always go straight to `/workforce` and never see onboarding (Q6).
 */
export function V3IndexRedirect() {
  const navigate = useNavigate();
  const { currentWorkspaceId } = useAuth();
  const tree = useListTree(currentWorkspaceId ?? undefined);
  const workspace = useWorkspaceInfo();
  const { completed, isLoading: onbLoading } = useOnboardingComplete();

  useEffect(() => {
    if (tree.isLoading || workspace.isLoading || onbLoading) return;

    const rootId = workspace.data?.root_node_id as string | undefined;
    const nonRootAgents = (tree.data ?? []).filter(
      (n) => n.type === "agent" && n.id !== rootId && !n.archived_at,
    );

    if (completed !== true && nonRootAgents.length === 0) {
      navigate("/welcome", { replace: true });
    } else {
      navigate("/workforce", { replace: true });
    }
  }, [tree.isLoading, tree.data, workspace.isLoading, workspace.data, onbLoading, completed, navigate]);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      color: "var(--color-text-tertiary)",
      fontSize: 13,
    }}>
      Loading...
    </div>
  );
}
